export function TeamSuggestions({
  opponents,
}: {
  opponents: Array<{ id: string; name: string }>;
  /** Non piu' usato: la competizione si sceglie con CompetitionPicker. */
  competitions?: Array<{ id: string; name: string; is_active?: boolean }>;
}) {
  return (
    <datalist id="team-opponents">
      {opponents.map((o) => (
        <option key={o.id} value={o.name} />
      ))}
    </datalist>
  );
}
